"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1145],{

/***/ 1145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfileHeadline": function() { return /* binding */ GarageProfileHeadline; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _eo_locale_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7245);






var GarageProfileHeadline = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GarageProfileHeadline, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(GarageProfileHeadline);
    function GarageProfileHeadline() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GarageProfileHeadline);
        return _super.apply(this, arguments);
    }
    var _proto = GarageProfileHeadline.prototype;
    _proto.render = function render() {
        var ref, ref1, ref2, ref3;
        var garage = this.props.garage;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "garageProfile__headline col-span-12 grid order-1 lg:order-none grid-cols-12 mb-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-span-12 md:col-span-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-2xl leading-8 lg:text-4xl lg:leading-10 font-medium font-serif text-gray-900 flex-grow mb-3",
                            children: garage.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid grid-cols-8 lg:flex-row gap-1 flex-wrap text-sm mb-3 justify-start md:flex md:flex-wrap",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-span-full md:col-span-2 order-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa-kit fa-star fa-fw text-yellow-500 text-regular relative inline-block"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: (garage.rating / 100 * 5).toFixed(2)
                                        }),
                                        " \xb7 ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            href: "#reviews",
                                            className: "font-light text-gray-900",
                                            children: [
                                                garage.review_count,
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                                    id: "ratings"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-span-full md:col-span-6 order-3 md:order-2 md:ml-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: "#garage-location",
                                        className: "font-light text-gray-900",
                                        children: [
                                            garage.street,
                                            " - ",
                                            garage.postcode,
                                            " ",
                                            garage.city,
                                            " ",
                                            (ref = garage.baseDistrict) === null || ref === void 0 ? void 0 : ref.name
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-span-full order-2 md:order-3 flex items-center gap-3 md:basis-full",
                                    children: [
                                        garage.garageConcept && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    loading: "lazy",
                                                    className: "h-6",
                                                    src: "https://werkstatt.repareo.de/storage/" + garage.garageConcept.logo,
                                                    alt: garage.garageConcept.name
                                                }),
                                                garage.garageConcept.name
                                            ]
                                        }),
                                        ((ref1 = garage.checkpoint) === null || ref1 === void 0 ? void 0 : ref1.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        width: "75",
                                                        src:  true && "https://werkstatt.repareo.de/storage/" + ((ref2 = garage.checkpoint) === null || ref2 === void 0 ? void 0 : ref2.logo),
                                                        alt: (ref3 = garage.checkpoint) === null || ref3 === void 0 ? void 0 : ref3.name
                                                    }),
                                                    " Pr\xfcfort"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-span-4 items-center justify-end hidden md:flex md:visible",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "#booking",
                        className: "relative bg-primary-500 px-12 py-2 mt-5 text-white rounded-lg font-normal text-center no-underline",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                            id: "book_appointment"
                        })
                    })
                })
            ]
        });
    };
    return GarageProfileHeadline;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);


/***/ })

}]);